import { Calendar } from 'data/firestore/agent/calendar/types';

export type CalendarHoliday = NonNullable<Calendar['holidays']>[number];

interface ParseResult {
    holidays: CalendarHoliday[];
    skipped: number;
}

const createId = () => (
    globalThis.crypto?.randomUUID?.()
    || `holiday-${Date.now()}-${Math.random().toString(36).slice(2)}`
);

const unescapeText = (value: string) => value
    .replace(/\\n/gi, ' ')
    .replace(/\\,/g, ',')
    .replace(/\\;/g, ';')
    .replace(/\\\\/g, '\\')
    .trim();

const isValidMonthDay = (month: number, day: number) => {
    const date = new Date(Date.UTC(2000, month - 1, day));
    return date.getUTCMonth() === month - 1 && date.getUTCDate() === day;
};

const getProperty = (eventLines: string[], propertyName: string) => {
    const prefix = `${propertyName.toUpperCase()}`;
    const line = eventLines.find((currentLine) => {
        const property = currentLine.split(':', 1)[0].split(';', 1)[0].toUpperCase();
        return property === prefix;
    });
    return line?.slice((line.indexOf(':') || 0) + 1);
};

const parseIcsHolidays = (contents: string): ParseResult => {
    const unfolded = contents.replace(/\r?\n[ \t]/g, '');
    const eventBlocks = unfolded.match(/BEGIN:VEVENT[\s\S]*?END:VEVENT/gi) || [];
    const holidays: CalendarHoliday[] = [];
    let skipped = 0;

    eventBlocks.forEach((block) => {
        const lines = block.split(/\r?\n/);
        const name = getProperty(lines, 'SUMMARY');
        const dateValue = getProperty(lines, 'DTSTART');
        const dateMatch = dateValue?.match(/^(\d{4})(\d{2})(\d{2})/);

        if (!name || !dateMatch) {
            skipped += 1;
            return;
        }

        const month = Number(dateMatch[2]);
        const day = Number(dateMatch[3]);
        if (!isValidMonthDay(month, day)) {
            skipped += 1;
            return;
        }

        holidays.push({
            id: createId(),
            name: unescapeText(name),
            month,
            day,
        });
    });

    return { holidays, skipped };
};

export default parseIcsHolidays;
